import { z } from 'zod';
export const SIMULATION_AMOUNT_LIMITS = {
    /** Minimum in cents (R$ 800,00 = 80000 centavos) */
    MIN: 80_000,
    /** Maximum in cents (R$ 30.000,00 = 3000000 centavos) */
    MAX: 3_000_000,
};
/** Validates requested amount in cents */
export const SimulationAmountCentsVO = z
    .number()
    .int()
    .min(SIMULATION_AMOUNT_LIMITS.MIN, `O valor mínimo para simulação é R$ 800,00.`)
    .max(SIMULATION_AMOUNT_LIMITS.MAX, `O valor máximo para simulação é R$ 30.000,00.`);
//# sourceMappingURL=simulation-amount.js.map